import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { FC, useState } from "react";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { TextField, Typography } from "@mui/material";
import { useFormClasses } from "./CreateOfferOrderForm.style";
import useLanguages from "../../../../explorer/hooks/useLanguages";
import { DateTime } from "luxon";
import { AppIconsDate } from "../../AppIcons";
import { useApiError } from "../../../hook/useApiError";

type TDeliveryDate = {
  onChange: any;
  onChangeDeliveryDateValid?:any;
};

const DeliveryDate: FC<TDeliveryDate> = (props) => {
  const { onChange,onChangeDeliveryDateValid } = props;
  const { t } = useTranslation();
  const classesForm = useFormClasses();
  const lang = useLanguages().currentLanguage;
  const [error, setError] = useState<string | null>(null);


  const [selectedDate, setSelectedDate] = useState<DateTime | null>(null);
  const [inputValue, setInputValue] = useState<string>('');

  const handleDateChange = (date: DateTime | null) => {
    setSelectedDate(date);
    onChangeDeliveryDateValid(true);
    /*
    onError={(reason, value) => {
                  if (reason) {
                      setError(t("orderoffer.invalidDate"));
                      onChange(null, "");
                      onChangeDeliveryDateValid(false);
                  } else {
                  }
              }}
                  */
    if (date!=null) {
        try{
            if (!date.isValid) {
                throw new Error('Invalid date');
            }
            onChange(null, date.toFormat("yyyyLLdd").toString());
            setError(null);
        }catch(_e){
            setError(t("orderoffer.invalidDate"));
            onChange(null, "");
            onChangeDeliveryDateValid(false);
        }
    } else {
        onChange(null, null);
        setError(null);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  return (
      <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={lang}>
          <Typography sx={classesForm.title}>
              {t("orderoffer.deliveryDate")}
          </Typography>
          <DatePicker
              value={selectedDate}
              slots={{
                  openPickerIcon: AppIconsDate,
                 
              }}
              slotProps={{
                  textField: {
                      variant: "standard",
                      error: !!error,
                      helperText: error ,
                     
                  },
              }}
              minDate={DateTime.now()}
              onChange={handleDateChange}
              
          />
      </LocalizationProvider>
  );
};

export default DeliveryDate;
